import { auth } from "../firebase";

export class AuthService {
  static startTokenAutoRefresh(refreshIntervalMinutes: number = 10) {
    return setInterval(async () => {
      console.debug("Token refreshing...");
      const user = auth.currentUser;
      if (user) {
        await user.getIdToken(true);
        console.debug("Token refreshed.");
      }
    }, refreshIntervalMinutes * 60 * 1000);
  }
}
